import { Flex, Skeleton } from "@scaleaq/sui-react";
import { Loading } from "../Loading/Loading";
import styles from "./LoadingGhost.module.scss";
import clsx from "clsx";

export namespace LoadingGhost {
    export type Props = Flex.Row.Props & {
        skeleton?: Skeleton.Props;
        loading?: Loading.Props;
    }
}

export const LoadingGhost = (props: LoadingGhost.Props) => {
    const { className, alignment = "center", skeleton, loading, ...restProps } = props;
    const { width = "100%", height = "3rem", variant = "soft", color = "action" } = skeleton ?? {};
    const { size = "small", className: loadingClassName, ...loadingRestProps } = loading ?? {};

    return(
        <Flex.Row alignment={alignment} {...restProps} className={clsx(styles["loading-indicator"], className)}>
			<Skeleton width={width} height={height} variant={variant} color={color} className={styles["loading-indicator-skeleton"]} />
			<Loading size={size} className={clsx(styles["loading-bubbles"], loadingClassName)} {...loadingRestProps} />
		</Flex.Row>
    );
}